// Copyright aptihealth, inc. 2019 All Rights Reserved

import React, { Component } from "react";
import Profile from "../../../components/Admin/Profile";
import { Route, Switch } from "react-router-dom";
import { adminRoute } from "../../../config/roles";

const BASE_ROUTE = adminRoute + "/profile";

class AdminProfile extends Component {
  render() {
    return (
      <div>
        <Switch>
          <Route path={BASE_ROUTE} render={(props) => <Profile {...props} />} />
        </Switch>
      </div>
    );
  }
}

export default AdminProfile;
